<div class="info-bar" *ngIf="showTrialBar && expiringDays">
  <p>
    {{
      "components.infoBar.expireInfoText" | translate : { days: expiringDays }
    }}
  </p>
</div>

<div class="info-bar" *ngIf="showImpersonationBar">
  <p>
    Currently impersonating another client.

    <button nbButton size="tiny" status="warning" (click)="stopImpersonate()">
      Stop Impersonation
    </button>
  </p>
</div>
